import { FirebaseApp, initializeApp } from 'firebase/app';
import { requireEnv } from '../../utils/env';

let app: FirebaseApp | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    const projectId = requireEnv('REACT_APP_FIREBASE_PROJECT_ID');

    app = initializeApp({
      apiKey: requireEnv('REACT_APP_FIREBASE_API_KEY'),
      authDomain: `${projectId}.firebaseapp.com`,
      databaseURL: `https://${projectId}.firebaseio.com`,
      projectId,
      storageBucket: `${projectId}.firebasestorage.app`,
      messagingSenderId: requireEnv('REACT_APP_FIREBASE_SENDER_ID'),
      appId: requireEnv('REACT_APP_FIREBASE_APP_ID'),
      measurementId: requireEnv('REACT_APP_FIREBASE_MEASUREMENT_ID'),
    });
  }

  return app;
}
